import { Button, Space, Typography, Form, Input, Divider, Row, Col, Tooltip } from "antd";
import { EditIcon, TrashIcon } from "../../admin/Icons";
import { ColorPicker } from 'react-color-gradient-picker';
import wrap from "../../utils/wrap";
import { canDeleteRecord, colorInfo, makeKey, tt_color_delete, tt_color_reset } from "../../utils/Utils";
import Overlay from "../Overlay";
import { useState } from "react";
import { RedoOutlined } from '@ant-design/icons';
export const getStyle = (_colors = [], _id = 0) => {
    let _f = _colors.find(item => item.id == _id);
    if (_f) {
        return _f.color.style;
    } else {
        return ""
    }
}

export default function Colour(props) {

    // Pass functions and parameters
    const {
        template = {},
        templates = [],
        reset = () => {},
        remove = () => { },
        save = () => { },
        close = () => { },
        is_new = false,
        is_edit = false,
        data = {}
    } = props;

    // Destructure / Default
    const {
        id = 0,
        name = "",
        red = 240,
        green = 240,
        blue = 240,
        alpha = 1,
        style = "rgba(240, 240, 240, 1)"
    } = data;

    const can_delete = canDeleteRecord(templates, template, id, "colours");
    const [form] = Form.useForm();
    // Structured object for picker component
    const [color, setColor] = useState(
        {
            color: {
                red: red,
                green: green,
                blue: blue,
                alpha: alpha,
            },
            style: style
        }
    )

    const drawPreview = () => {
        return (<div className="color-preview" style={{ "background": style }}></div>)
    }

    // Save Colour

    const saveColor = (_form) => {

        _form.red = (color.red >= 0) ? color.red : red;
        _form.green = (color.green >= 0) ? color.green : green;
        _form.blue = (color.blue >= 0) ? color.blue : blue;
        _form.alpha = (color.alpha >= 0) ? color.alpha : alpha;
        _form.style = (color.style) ? color.style : style;

        save(_form, is_new, false);
        close();
    }

    // Update State
    const updateColor = (_color) => {

        setColor(_color)
    }

    // Draw the edit form
    const drawEdit = () => {
        let _new = (is_new) ? "New" : "Edit";
        return (
            <div onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        form.submit();
                        e.stopPropagation();
                        e.preventDefault();
                    }
                }} key={id} style={{ "padding": "20px" }}>
                <Typography.Title level={5}>{_new} {(!name && <>Solid Colour</>)} {(name && <em>"{name}"</em>)}</Typography.Title>
                <Divider style={{ "margin": "15px 0px" }} dashed />

                <Form form={form} onFinish={(_f) => saveColor(_f)} layout="vertical">

                    <Row gutter={10}>
                        <Col span={16}>
                            <Form.Item initialValue={name} rules={[{ required: true, message: "Colour name is required." }]} name="name" label={<>Colour name<small><em>&nbsp; (Max 20 chars)</em></small></>}>
                                <Input placeholder="Colour name..." maxLength={20} />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <div className="checker-bg" style={{ "width": "75px", "height": "30px", "borderRadius": "4px", "marginTop": "25px" }}>
                                <div style={{ "backgroundColor": color.style, "width": "75px", "height": "30px", "border" : "1px solid #ddd", "borderRadius": "4px" }}></div>
                            </div>
                        </Col>
                    </Row>
                    <Form.Item name="id" initialValue={(id) ? id : makeKey()} noStyle>
                        <Input hidden />
                    </Form.Item>
                    <ColorPicker color={data} onStartChange={updateColor} onEndChange={updateColor} onChange={updateColor} />
                    <div style={{ "textAlign": "center", "top": "-110px", "position": "relative" }}><small>Opacity</small></div>
                    <div className="shim" /><div className="shim" />
                    <div className="float-flex">
                        <div>&nbsp;</div>
                        <div><Button htmlType="submit" type="primary">Save</Button></div>
                    </div>
                </Form>
                {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
            </div>
        )
    }

    // Draw the row (Allow clicking on the color to edit)
    const drawRow = () => {
        return (
            <div>
                <div className="float-flex">
                    <Space>
                        <Overlay width="320px" component={<Colour is_edit save={save} data={data} />}>
                            <Space>
                            <Tooltip placement="right" title={<small>{colorInfo(data)}</small>}>{drawPreview()}</Tooltip>
                            <wrap.tags><div style={{"cursor" : "pointer"}}>{name}</div></wrap.tags>
                            </Space>
                        </Overlay>
                    </Space>
                    <Space size={0}>
                        {(can_delete && <Tooltip placement="left" title={tt_color_delete}><Button onClick={() => remove(id, false)} type="link" icon={<TrashIcon />} size="small" /></Tooltip>)}
                        {(!can_delete && <Tooltip placement="left" title={tt_color_reset}><Button onClick={() => reset(id, false)} type="link" icon={<RedoOutlined />} size="small" /></Tooltip>)}
                        <Overlay width="320px" component={<Colour is_edit save={save} data={data} />}>
                            <Button type="link" icon={<EditIcon />} size="small" />
                        </Overlay>
                    </Space>
                </div>
                <div className="shim" />
            </div>
        )
    }

    if (is_new || is_edit) {
        return drawEdit();
    } else {
        return drawRow();
    }

}